import React, {Component} from 'react'

class Error extends Component{
	render(){
		const { error_message } = this.props
		return (
			<div className="error-center">
				<div className="alert alert-danger">
					<strong>
						{error_message}
					</strong>
				</div>
			</div>
		)
	}
}

export default Error
